/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutAudioPromptPolicy = typeof OrgSettingsPutAudioPromptPolicy[keyof typeof OrgSettingsPutAudioPromptPolicy] | null;


export const OrgSettingsPutAudioPromptPolicy = {
  first_external: 'first_external',
  each: 'each',
  off: 'off',
} as const;
